import { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { ErrorResponse, privateApi } from 'api';

import { ChargeFormValues } from 'components/Dialogs/Finance/ChargeDialog/ChargeSchema';

import { Charge } from './GetCharge';

export type UpdateChargeResult = Charge | null;
export type UpdateChargeParams = ChargeFormValues;

async function updateCharge(params: UpdateChargeParams): Promise<UpdateChargeResult> {
  // ensure charge has an id
  if (!params?.id) {
    throw new Error('Charge id is required');
  }

  // make api call
  const result = await privateApi.put(`${import.meta.env.VITE_API_BASE_URL}/finance/charges/${params.id}`, params);

  // return the data object
  return result.data as Charge;
}

const useUpdateCharge = createMutation<UpdateChargeResult, UpdateChargeParams, AxiosError<ErrorResponse>>({
  mutationFn: async (variables) => updateCharge(variables),
});

export { updateCharge, useUpdateCharge };
